<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="title"><a id="page_i"></a><b>THE</b></p>
<p class="title1">DEMON</p>
<p class="title1a">LOVER</p>
<p class="title2">DION FORTUNE</p>
<p class="title2a"><img alt="images" src="images/pub.jpg" style="margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ad6489fc